// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as UnitSynergiesTable from "./UnitSynergiesTable.bs.js";
import * as TraitSynergiesTable from "./TraitSynergiesTable.bs.js";
import * as AugmentSynergiesTable from "./AugmentSynergiesTable.bs.js";

function TraitStatsTables(Props) {
  var inContext = Props.inContext;
  var traitStats = Props.traitStats;
  var scrollRef = Props.scrollRef;
  var match = React.useState(function () {
        return /* Units */1;
      });
  var setTab = match[1];
  var tab = match[0];
  var totCount = traitStats.base.count;
  var tmp;
  switch (tab) {
    case /* Augments */0 :
        var tmp$1 = {
          augments: traitStats.augments,
          aug1s: traitStats.aug1s,
          aug2s: traitStats.aug2s,
          aug3s: traitStats.aug3s,
          totCount: totCount,
          inContext: inContext
        };
        if (scrollRef !== undefined) {
          tmp$1.scrollRef = Caml_option.valFromOption(scrollRef);
        }
        tmp = React.createElement(AugmentSynergiesTable.make, tmp$1);
        break;
    case /* Units */1 :
        var tmp$2 = {
          units: traitStats.units,
          totCount: totCount,
          inContext: inContext
        };
        if (scrollRef !== undefined) {
          tmp$2.scrollRef = Caml_option.valFromOption(scrollRef);
        }
        tmp = React.createElement(UnitSynergiesTable.make, tmp$2);
        break;
    case /* Traits */2 :
        var tmp$3 = {
          traits: traitStats.traits,
          totCount: totCount,
          inContext: inContext
        };
        if (scrollRef !== undefined) {
          tmp$3.scrollRef = Caml_option.valFromOption(scrollRef);
        }
        tmp = React.createElement(TraitSynergiesTable.make, tmp$3);
        break;
    
  }
  return React.createElement(ContentSection.make, {
              className: "px-0 py-0",
              children: null
            }, React.createElement("div", {
                  className: "flex justify-end pt-2"
                }, React.createElement(Tabs, {
                      children: null,
                      value: tab,
                      onChange: (function (param, t) {
                          return Curry._1(setTab, (function (param) {
                                        return t;
                                      }));
                        })
                    }, React.createElement(Tab, {
                          label: "Units",
                          value: /* Units */1
                        }), React.createElement(Tab, {
                          label: "Traits",
                          value: /* Traits */2
                        }))), tmp);
}

var make = TraitStatsTables;

export {
  make ,
  
}
/* react Not a pure module */
